import React from 'react';
import Printer from 'services/Printer';
import { Spinner, SimpleSelect } from 'components/atoms';
import { handleErrors } from 'services/utils';
import LocalStorage from 'services/LocalStore';

let inlineMediaStyle = null;

function applyPrinter(printer={}, orientation='portrait') {
  const margins = {
    top: printer.tmargin || 0,
    right: printer.rmargin || 0,
    bottom: printer.bmargin || 0,
    left: printer.lmargin || 0,
  }
  setMargins({ margins, orientation });
}

function setMargins( settings={} ) {
  // debugger;
  const margins = settings.margins;
  const marginsStr = `${margins.top}mm ${margins.right}mm ${margins.bottom}mm ${margins.left}mm `;
  let myhead = document.getElementsByTagName('head')[0];
  let newStyle = document.createElement('style');
      newStyle.setAttribute('type', 'text/css');
      newStyle.setAttribute('media', 'print');

  const printStyles = `@page {size: ${settings.orientation}; margin: ${marginsStr}; }`;
  
  newStyle.appendChild(document.createTextNode(printStyles));

  if (inlineMediaStyle) {
    myhead.replaceChild(newStyle, inlineMediaStyle);
  } else {
    myhead.appendChild(newStyle);
  }
  inlineMediaStyle = newStyle;
}

export default class PrinterSelect extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      printers: [],
      currentPrinterId: '',
      loading: true,
    }
    this.lastUsedPrinter = LocalStorage.get('lastUsedPrinter');
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadData = () => {
    this.setState({loading: true});
    Printer.query().then(({items, paging}) => {
      if (this.mounted) {
        this.setState({ printers: items || [], loading: false }, () => {
          this.printerChosen({target: {value: this.lastUsedPrinter || 0}})
        });
      }
    }).catch(handleErrors).then(() => {
      if (this.mounted) {
        this.setState({ loading: false });
      }
    });
  }

  printerChosen = ({target: {value}}) => {
    const pId = parseInt(value);
    let printer = null;
    if (pId) {
      printer = this.state.printers.find(printer => printer.id === pId);
    }
    if (printer) {
      applyPrinter(printer, this.props.orientation || 'portrait');
      this.setState({ currentPrinterId: pId });
      LocalStorage.set('lastUsedPrinter', pId);
    } else {
      applyPrinter();
    }
  }

  render() {
    const {printers, currentPrinterId, loading} = this.state;
    if (loading) {
      return <Spinner />;
    }
    const className = this.props.className || 'form-select';
    return (
      <SimpleSelect optValue="id" optLabel="name" fieldName="printerId" placeholder="Выберите принтер"
        className={className} value={currentPrinterId} list={printers} onChange={this.printerChosen} />
    )

  }
}